__webpack_require__.p = "/tfjs-hand/";